import React, { Component } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Divider,
  MenuItem,
} from "@mui/material";
import Sidebar from "../Sidebar";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import base from "../base.json";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

const drawerWidth = 80;
export class AddCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {

         company_name :  String,
         company_phone : String,
       
         company_email : String,
         company_login_passcode:String,
       
         company_address : String, 
         company_logo:String,
         description:String,
       
         company_available_fund: 0,
          
         company_type:String,

      is_switch_case: true,
    };
    this.handleChange = this.handleChange.bind();
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangee = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  handleChangeee = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };


  
  save = () => {
    
    if (

           this.state.company_name !=   "" &&
         this.state.company_phone !=  "" &&
       
         this.state.company_email !=  "" &&
         this.state.company_login_passcode!= "" &&
       
         this.state.company_address !=  "" && 
         this.state.company_logo!= "" &&
         this.state.description!= "" &&
          
         this.state.company_type!= "" 


    ) {

      let formdata = new FormData();

      formdata.append("company_name", this.state.company_name);
      formdata.append(
        "company_phone",
        this.state.company_phone
      );

      formdata.append("company_email", this.state.company_email);
    
      formdata.append(
        "company_login_passcode",
        this.state.company_login_passcode
      );
      formdata.append("company_address", this.state.company_address);


      formdata.append("company_logo", this.state.company_logo);


      formdata.append("description", this.state.description);
         formdata.append("company_type", this.state.company_type);


      this.setState({ is_loader_shows: true }, () => {
        fetch(
          `${base.base_url}/job_portal/admin/company/AddNewCompany`,
          {
            /*
        headers: {
                                "content-type": "multipart/form-data",
                              },
                              */
            method: "post",
            body: formdata,
          }
        )
          .then((res) => {
            return res.json();
          })
          .then(() => {
            alert("done");
          });
      });
    } else {
      alert("fill all fields");
    }

  };
  

  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            <Box
              sx={{
                height: 47,
                //  width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>
                Add Company
              </Typography>

              <Link to="/">
                <Button
                  variant="contained"
                  size="samll"
                  startIcon={
                    <FormatListNumberedOutlinedIcon
                      sx={{ height: 20, width: 20 }}
                    />
                  }
                  disableElevation
                  sx={{
                    height: 25,
                    fontSize: 13,
                    textTransform: "none",
                    backgroundColor: "#288ade",
                    mr: 1,
                  }}
                >
                  Company List
                </Button>
              </Link>
            </Box>

            <Box
              sx={{
                pl: { xs: 1, sm: 3 },
                pt: { xs: 1, sm: 3 },
                pr: { xs: 1, sm: 3 },
                display: this.state.is_switch_case ? "block" : "none",
              }}
            >
              <Box>
                <Paper
                  variant="outlined"
                  elevation={1}
                  style={{ minHeight: 150, width: "100%", color: "#fff" }}
                >
                  <Box sx={{ padding: 3 }}>
                    <Typography
                      style={{
                        fontWeight: "bold",
                        color: "#1b7bce",
                        fontSize: 13,
                        marginTop: 3,
                        textTransform: "uppercase",
                        marginBottom: 8,
                        marginLeft: 1,
                      }}
                    >
                      Fill company details
                    </Typography>

                    <Grid container spacing={2}>
                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Company name
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Company name"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="company_name"
                          value={this.state.company_name}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Company phone
                        </Typography>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="company phone"
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="company_phone"
                          value={this.state.company_phone}
                          onChange={this.handleChange}
                             />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Company email
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Company email"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="company_email"
                          value={this.state.company_email}
                          onChange={this.handleChange}
                           />

                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Password
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="password"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="company_login_passcode"
                          value={this.state.company_login_passcode}
                          onChange={this.handleChange}
                        />
                      </Grid>

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                        Address
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="company address"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="company_address"
                          value={this.state.company_address}
                          onChange={this.handleChange}
                        />
                      </Grid>

                   

                         <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Description
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="description"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          name="description"
                          value={this.state.description}
                          onChange={this.handleChange}
                        />
                      </Grid>


            

                      <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                         Company Logo
                        </Typography>
                        <Box
                          sx={{
                            width: "100%",
                            height: 32,
                            backgroundColor: "#f8f8f8",
                            border: 1,
                            borderColor: "#a0a0a0",
                            borderRadius: 1,
                          }}
                        >
                          <input
                            type="file"
                            name="company_logo"
                            onChange={this.handleChangee}
                            style={{
                              margin: 6,
                              paddingTop: 2,
                              borderRadius: 2,
                              color: "grey",
                              fontSize: 10,
                            }}
                          />
                        </Box>
                      </Grid>


                          <Grid item size={{ xs: 12, sm: 6, md: 3}}>
                        <Typography
                          sx={{
                            fontSize: 11,
                            color: "#515151",
                            fontWeight: "bold",
                            p: 0.5,
                          }}
                        >
                          Company Type
                        </Typography>
                        <TextField
                          size="small"
                          type="text"
                          placeholder="company_type"
                          fullWidth
                          InputProps={{
                            style: { fontSize: 11, fontWeight: "500" },
                          }}
                          select
                          name="company_type"
                          value={this.state.company_type}
                          onChange={this.handleChange}
                        >
                          {[
                            "FOREIGN MNC",
                            "INDIAN MNC",
                            "STARTUP","CORPORATES",
                          ].map((option) => (
                            <MenuItem
                              sx={{ fontSize: 11, fontWeight: "bold" }}
                              key={option}
                              value={option}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
             


                    </Grid>

        

                    <br />

                    <Box>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none", fontSize: 12 }}
                        onClick={this.save}
                      >
                        Save Builder Details
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Box>

              <br />
              <br />
              <br />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default AddCompany;

export function AddCompanyc(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams();
  return <AddCompany param={param} navigate={navigate}></AddCompany>;
}




 






